"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsumerDisruptionProvider = exports.ConsumerDisruptionContext = void 0;
var react_1 = __importStar(require("react"));
var ConsumerDisruptionContext = (0, react_1.createContext)(null);
exports.ConsumerDisruptionContext = ConsumerDisruptionContext;
/**
 * @description Provider allows to have multiple `ConsumerDisruptionButton`s stay in sync. i.e. when 1 closes they all close and vice versa
 * @param children all `ConsumerDisruptionButton`s should be wrapped by this component
 */
var ConsumerDisruptionProvider = function (_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)(true), contextIsOpen = _b[0], setContextIsOpen = _b[1];
    return (react_1.default.createElement(ConsumerDisruptionContext.Provider, { value: { isOpen: contextIsOpen, setIsOpen: setContextIsOpen } }, children));
};
exports.ConsumerDisruptionProvider = ConsumerDisruptionProvider;
